/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 */
import React from 'react';

const CIRCUMFERENCE = 2 * Math.PI * 10;

/** 24px progress ring with an icon in the middle (uses currentColor). */
export const ProgressRing = ({ percent, Icon }) => (
  <span className="relative inline-flex items-center justify-center w-6 h-6" aria-hidden="true">
    <svg viewBox="0 0 24 24" className="w-6 h-6 -rotate-90">
      <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeOpacity="0.2" strokeWidth="2" />
      <circle
        cx="12" cy="12" r="10" fill="none" stroke="currentColor"
        strokeWidth="2" strokeLinecap="round"
        strokeDasharray={CIRCUMFERENCE}
        strokeDashoffset={CIRCUMFERENCE * (1 - percent / 100)}
      />
    </svg>
    <Icon className="absolute h-3 w-3" />
  </span>
);
